<template>
  <!-- v-show="!(this.$mq === 'xs' && this.isMenuVisible)" -->
  <div class="content" :style="styleContent">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Content",
  computed: {
    ...mapState(["isMenuVisible"]),
    styleContent() {
      if ((this.$mq === "xs" || this.$mq === "sm") && this.isMenuVisible) {
        return "width: 0; display: none;";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.content {
  grid-area: content;
  background-color: #fff;
  z-index: 1;
  height: calc(100vh - 48px);
  overflow: auto;
}
</style>